import React                     from 'react';
import classNames                from 'classnames';
import { Observe }               from 'rewire-core';
import {
  WithStyle,
  FormView
}                                from 'rewire-ui';
import { Theme }                 from '@material-ui/core/styles';
import { withStyles }            from '../utility/styles';
import DraggableResizableDialog  from '../ui/DraggableResizableDialog';
import auditLogFilterDialogModel from './AuditLogFilterDialogModel';
import Typography                from '@material-ui/core/Typography';

const styles = (_theme: Theme) => ({
  placeholder: {
    '& input': {
      fontStyle: 'italic',
    },
    '& span > span': {
      fontStyle: 'italic',
    },
  },
  title: {
    margin: '0px 16px',
  }
});

interface IAuditLogFilterDialogProps {
}

type AuditLogFilterDialogProps = WithStyle<ReturnType<typeof styles>, IAuditLogFilterDialogProps>;

class AuditLogFilterDialog extends React.PureComponent<AuditLogFilterDialogProps> {
  constructor(props: AuditLogFilterDialogProps) {
    super(props);
  }

  componentWillUnmount() {
    auditLogFilterDialogModel.reset();
  }

  renderFormContents = React.memo((): JSX.Element | null => {
    const { classes } = this.props;
    const field       = auditLogFilterDialogModel.form.field;
    return (
      < >
        <Typography variant='h6' className={classes.title}>Audit Log Filters</Typography>
        { field.types.visible            && <div className='content'><field.types.Editor      className={classNames(classes.placeholder, 'span4')} /></div> }
        { field.operations.visible       && <div className='content'><field.operations.Editor className={classNames(classes.placeholder, 'span4')} /></div> }
        { field.createdBy.visible        && <div className='content'><field.createdBy.Editor  className={classNames(classes.placeholder, 'span4')} /></div> }
        { field.createdDateStart.visible && field.createdDateEnd.visible && 
          <div className='content'>
            <field.createdDateStart.Editor className={classNames(classes.placeholder, 'span2')} />
            <field.createdDateEnd.Editor   className={classNames(classes.placeholder, 'span2')} />
          </div>
        }
        { field.effectiveStart.visible && field.effectiveEnd.visible && 
          <div className='content'>
            <field.effectiveStart.Editor className={classNames(classes.placeholder, 'span2')} />
            <field.effectiveEnd.Editor   className={classNames(classes.placeholder, 'span2')} />
          </div>
        }
        { field.employees.visible &&
          <>
          <Typography variant='h6' className={classes.title}>Data Filters</Typography>
          <div className='content'><field.employees.Editor className={classNames(classes.placeholder, 'span4')} /></div>
          </>
        }
      </>
    );
  });

  renderDialogContents = React.memo((): JSX.Element => {
    return <Observe render={() => (
      <FormView form={auditLogFilterDialogModel.form} onSubmit={auditLogFilterDialogModel.actionFn('apply')}>
        <this.renderFormContents />
      </FormView>
    )} />;
  });

  render() {
    return <Observe render={() => (
      <DraggableResizableDialog defaultWidth='sm' DialogProps={{dialog: auditLogFilterDialogModel, actions: ['cancel', 'apply']}} DraggableResizableBoxProps={{minWidth: '345px', minHeight: '480px'}}>
        <this.renderDialogContents />
      </DraggableResizableDialog>
    )} />;
  }
}

export default withStyles<IAuditLogFilterDialogProps>(styles, AuditLogFilterDialog);
